import React from 'react';
import '../../style/App.css';
import './alert-panel.css';

export const AlertPanel = (props: { content: any, onClose?: any; level?: 'INFO' | 'WARNING' | 'ERROR' }): JSX.Element => {

    return (
        <React.Fragment>
            <div
                className={'popup-list-backpan alert-panel-backpan'}
                onClick={clickEvent => {
                    clickEvent.stopPropagation();
                    clickEvent.preventDefault();
                    if( typeof props.onClose === 'function' ) {
                        props.onClose();
                    }
                }}
            >
                <div
                    className={`modal-container alert-panel${ !!props.level ? ('-'+ props.level) : '' }`}
                >
                    { props.content }
                </div>
            </div>
        </React.Fragment>
    );
}
